import * as React from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import NewbieReg1x from "../../../../images/_anti/banners/newbie/Desktop_reg_1x.jpg";
import NewbieReg2x from "../../../../images/_anti/banners/newbie/Desktop_reg_2x.jpg";
import NewbieMobileReg1x from "../../../../images/_anti/banners/newbie/Mobile_reg_1x.jpg";
import NewbieMobileReg2x from "../../../../images/_anti/banners/newbie/Mobile_reg_2x.jpg";
import NewbieNC1x from "../../../../images/_anti/banners/newbie/Desktop_no-contact_1x.jpg";
import NewbieNC2x from "../../../../images/_anti/banners/newbie/Desktop_no-contact_2x.jpg";
import NewbieMobileNC1x from "../../../../images/_anti/banners/newbie/Mobile_no-contact_1x.jpg";
import NewbieMobileNCx from "../../../../images/_anti/banners/newbie/Mobile_no-contact_2x.jpg";
import NewbieSent1x from "../../../../images/_anti/banners/newbie/Desktop_sent_1x.jpg";
import NewbieSent2x from "../../../../images/_anti/banners/newbie/Desktop_sent_2x.jpg";
import NewbieMobileSent1x from "../../../../images/_anti/banners/newbie/Mobile_sent_1x.jpg";
import NewbieMobileSent2x from "../../../../images/_anti/banners/newbie/Mobile_sent_2x.jpg";
import { MobXProviderContext } from "mobx-react";
import ProfileStore from "../../store/profile.store";
import { PromotionBanner } from "../PromotionBanner";
import http from "../../api/client";
import { tl } from "../../utils";
import FSNotifierStore from "../Notifier/store";

export interface NewbieBannerProps {
}

type TBannerState = 'registered' | 'no-contact' | 'sent';

export const NewbieBanner: React.FC<NewbieBannerProps> = (props) => {
  const classes = useStyles();
  const { profileStore, fsNotifierStore } = React.useContext<{
    profileStore: ProfileStore;
    fsNotifierStore: FSNotifierStore;
  }>(MobXProviderContext);

  const [bannerState, setBannerState] = React.useState<TBannerState>('registered');
  const [show, setShow] = React.useState(false);

  async function handleClick() {
    const hasContacts = !!profileStore.profile.phones?.length || !!profileStore.profile.userProfile?.telegram?.id;
    if (hasContacts) {
      try {
        const res = await http.post('/api/course/consult');
        if (res.status  === 200) {
          setBannerState('sent');
          localStorage.setItem('newbieBanner', 'false');
        } else {
          fsNotifierStore.addNotice(tl("Произошла ошибка. Повторите позднее"), "error");
        }
      } catch (error) {
        if (error?.response?.data?.errorMessage === 'empty_contact') {
          setBannerState('no-contact');
          localStorage.setItem('newbieBanner', 'false');
        } else {
          fsNotifierStore.addNotice(tl("Произошла ошибка. Повторите позднее"), "error");
        }
      }
    } else {
      setBannerState('no-contact')
      localStorage.setItem('newbieBanner', 'false');
    }
  }

  React.useEffect(() => {
    profileStore.init('');
    
    const headerBannerCloseDate = localStorage.getItem("headerBannerCloseDate");
    const newbieBannerClosed = localStorage.getItem("newbieBanner") === 'false';
    if (headerBannerCloseDate) {
      const difference = +headerBannerCloseDate - Date.now();
      if (difference > 30 * 24 * 60 * 60 * 1000) {
        setShow(window.location.pathname === '/panel/courses' && !newbieBannerClosed);
      } else {
        setShow(!newbieBannerClosed);
      }
    } else {
      setShow(window.location.pathname === '/panel/courses' && !newbieBannerClosed);
    }
  }, []);

  const renderSwitch = () => {
    switch (bannerState) {
      case 'registered':
        return (
          <>
            <source
              media="(min-width: 461px)"
              srcSet={`${NewbieReg1x} 1x, ${NewbieReg2x} 2x`}
              type="image/jpg"
            />
            <source
              media="(max-width: 460px)"
              srcSet={`${NewbieMobileReg1x} 1x, ${NewbieMobileReg2x} 2x`}
              type="image/jpg"
            />
            <button className={classes.btn} onClick={handleClick}></button>
          </>
        );
      case 'no-contact':
        return (
          <>
            <source
              media="(min-width: 461px)"
              srcSet={`${NewbieNC1x} 1x, ${NewbieNC2x} 2x`}
              type="image/jpg"
            />
            <source
              media="(max-width: 460px)"
              srcSet={`${NewbieMobileNC1x} 1x, ${NewbieMobileNCx} 2x`}
              type="image/jpg"
            />
          </>
        );
      case 'sent':
        return (
          <>
            <source
              media="(min-width: 461px)"
              srcSet={`${NewbieSent1x} 1x, ${NewbieSent2x} 2x`}
              type="image/jpg"
            />
            <source
              media="(max-width: 460px)"
              srcSet={`${NewbieMobileSent1x} 1x, ${NewbieMobileSent2x} 2x`}
              type="image/jpg"
            />
          </>
        );
    }
  }

  return (
    <>
      {window._user.isSuperNewbie && show && (
        <div className={classes.wrap}>
          <PromotionBanner
            name="newbieBanner"
          >
            {renderSwitch()}
    
            <img
              alt="New User Banner"
            />
          </PromotionBanner> 
        </div>
      )}
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  wrap: {
    marginBottom: 16,

    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1.25),
    },
  },
  btn: { 
    position: 'absolute',
    cursor: 'pointer',
    bottom: '6%',
    right: '16%',
    width: '22%',
    height: '24%',

    '@media screen and (max-width: 460px)': {
      bottom: '8%',
      right: '24%',
      width: '70%',
      height: '17%',
    },
  },
}));
